import React from "react";
import { Box } from "@mui/material";

import logo from "../../../assets/images/logo.svg";

const Logo = ({ width = 100 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <img
        src={logo}
        alt="Klooma Logo"
        width={width}
        style={{ display: "block" }}
      />
    </Box>
  );
};

export default Logo;
